// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"559":"291066ea","787":"de92d679"}[chunkId] + ".chunk.js";
};